export const INIT_NEW_CUSTOMER = 'customer/init-new-customer';
export const UPDATE_CUSTOMER = 'order/update-customer';
